module.exports = __webpack_public_path__ + "static/media/logo-prowin-messenger-white.5a7091a2.svg";